import { USD_PER_AI_CREDIT } from "./aiCredits.js";
const CREDIT_PACK_SUBSCRIPTION_OFFERS = {
  ai_credits: {
    unitPriceUsd: USD_PER_AI_CREDIT,
    presetQuantities: [1e3, 2500, 5e3],
    minQuantity: 100,
    maxQuantity: 1e5
  }
};
export {
  CREDIT_PACK_SUBSCRIPTION_OFFERS
};
//# sourceMappingURL=creditPackSubscription.js.map
